/**
 * Applies a confirmed color (variant-picker:confirm) to its configurator card: checkbox value,
 * unit price, stock, image and unit-price text. The `change` event makes the block recalculate.
 */
document.addEventListener('variant-picker:confirm', (event) => {
  const card = event.target.closest('[data-configurator-item]');
  const { variant, optionValue, changed } = event.detail;
  if (!card || !changed) return;

  const checkbox = card.querySelector('[data-configurator-checkbox]');
  if (!checkbox) return;

  checkbox.value = String(variant.id);
  card.setAttribute('data-unit-price', String(variant.price));
  if (variant.stock === null) {
    card.removeAttribute('data-stock');
  } else {
    card.setAttribute('data-stock', String(variant.stock));
  }

  const image = card.querySelector('[data-configurator-item-image]');
  if (image && variant.image) {
    image.src = variant.image;
    image.alt = optionValue;
  }

  const unitPrice = card.querySelector('[data-configurator-item-unit-price]');
  if (unitPrice) {
    unitPrice.textContent = variant.unitPrice;
    unitPrice.hidden = !variant.unitPrice;
  }

  checkbox.dispatchEvent(new Event('change', { bubbles: true }));
});
